"use client";

import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { PAGE_ROUTES } from "@/app/_utils/constants";
import ScrollReveal from "@/app/components/ScrollReveal";

const pageFont = '"Inter", "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif';

const quotes = [
  { outlet: "TIME OUT", quote: "This secret NYC comedy show pops up in the city's most surprising places" },
  { outlet: "NEW YORK POST", quote: "The historic Paragon Sports store hosted Comedy UO for a two-day event featuring 30 comics" },
  { outlet: "DAILY MAIL", quote: "Comedy Underground Overground transforms the humble laundromat into a vibrant part of urban life" },
  { outlet: "VULTURE", quote: "Raw, funny, and completely unexpected" },
];

export default function WhatTheyreSaying() {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#0d0d0d",
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 4 },
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ maxWidth: 1100, mx: "auto", width: "100%" }}>
        <ScrollReveal variant="fadeUp">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "stretch", md: "flex-end" },
            justifyContent: "space-between",
            gap: 2,
            mb: 4,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: pageFont,
                fontSize: "0.7rem",
                fontWeight: 600,
                letterSpacing: "0.2em",
                color: "rgba(255,255,255,0.5)",
                textTransform: "uppercase",
                mb: 0.5,
              }}
            >
              Press
            </Typography>
            <Typography
              component="h2"
              sx={{
                fontFamily: pageFont,
                fontWeight: 700,
                fontSize: { xs: "1.75rem", md: "2.25rem" },
                color: "#fff",
              }}
            >
              Friendly Propaganda
            </Typography>
          </Box>
          <Link to={PAGE_ROUTES.PRESS} style={{ textDecoration: "none" }}>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.75,
                fontFamily: pageFont,
                fontWeight: 600,
                fontSize: "0.9rem",
                color: "#fff",
                backgroundColor: "rgba(255,255,255,0.08)",
                border: "1px solid rgba(255,255,255,0.12)",
                borderRadius: "8px",
                py: 1.25,
                px: 2,
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.12)",
                },
              }}
            >
              View All Press
              <ArrowForwardIcon sx={{ fontSize: 18 }} />
            </Box>
          </Link>
        </Box>
        </ScrollReveal>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
            gap: 2,
          }}
        >
          {quotes.map((item, i) => (
            <ScrollReveal key={item.outlet} variant="fadeUp" delay={i * 0.1}>
            <Box
              sx={{
                backgroundColor: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: "12px",
                p: 2.5,
              }}
            >
              <Typography
                sx={{
                  fontFamily: pageFont,
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  letterSpacing: "0.08em",
                  color: "rgba(255,255,255,0.6)",
                  textTransform: "uppercase",
                  mb: 1,
                }}
              >
                {item.outlet}
              </Typography>
              <Box
                sx={{
                  width: 32,
                  height: 2,
                  backgroundColor: "rgba(255,255,255,0.2)",
                  mb: 1.5,
                }}
              />
              <Typography
                sx={{
                  fontFamily: pageFont,
                  fontWeight: 600,
                  fontSize: { xs: "1.1rem", md: "1.2rem" },
                  lineHeight: 1.4,
                  color: "#fff",
                }}
              >
                &ldquo;{item.quote}&rdquo;
              </Typography>
            </Box>
            </ScrollReveal>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
